// extracted by mini-css-extract-plugin
export default {"main":"Main_main__SqrVH","main__heading":"Main_main__heading__CyDTJ","animationGradient":"Main_animationGradient__wYk8i"};